import React from 'react';
import {hasRole, ROLES} from '../../auth/rbac';
import {useAppSelector} from '../../store/hooks';

export interface AdminGateProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    loadingFallback?: React.ReactNode;
}

const AdminGate: React.FC<AdminGateProps> = ({children, fallback = null, loadingFallback = null}) => {
    const isLoading = useAppSelector((state) => state.auth.isLoading);
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const roles = useAppSelector((state) => state.user.profile?.roles);

    if (isLoading) return <>{loadingFallback}</>;
    if (!isAuthenticated || !hasRole(roles, ROLES.ADMIN)) return <>{fallback}</>;

    return <>{children}</>;
};

export default AdminGate;
